import { ZodError, type ZodIssue, type ZodRawShape, type z } from 'zod';

export const createEnv = <T extends ZodRawShape>(schema: z.ZodObject<T>) => {
  try {
    return schema.parse(process.env);
  } catch (e) {
    if (!(e instanceof ZodError)) throw e;

    e.issues.forEach((issue: ZodIssue) => {
      console.error(`${issue.message}: ${issue.path.join(',')}`);
    });
    process.exit(-1);
  }
};
